import React from 'react';
import { chipStyle } from '../constants';

interface ChipProps {
	readonly icon?: React.ReactNode;
	readonly children: React.ReactNode;
}

export default function Chip({ icon: chipIcon, children }: ChipProps) {
	return (
		<div style={chipStyle}>
			{chipIcon && <span style={{ marginRight: 6 }}>{chipIcon}</span>}
			{children}
		</div>
	);
}
